import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error: unknown) => {
        const e = error as { response?: { status?: number } };
        if (e?.response?.status && [400, 401, 403, 404].includes(e.response.status)) return false;
        return failureCount < 2;
      },
    },
    mutations: { retry: 0 },
  },
});
